'use client';

import { Credenza, CredenzaContent, CredenzaHeader, CredenzaTitle, CredenzaBody } from "@/components/shared/credenza";
import { CustomForm } from "@/components/forms";
import { useEffect, useState } from 'react';

interface DownloadFormModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title?: string;
    formComponent?: React.ReactNode;
}

export function DownloadFormModal({ 
    open, 
    onOpenChange,
    title,
    formComponent = <CustomForm formId="d1004-download-neuroscience-perspective" />
}: DownloadFormModalProps) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return null;
    }

    return (
        <Credenza open={open} onOpenChange={onOpenChange}>
            <CredenzaContent className="mx-auto w-full sm:w-5/12 max-h-[90vh] overflow-y-auto">
                {title && (
                    <CredenzaHeader>
                        <CredenzaTitle className="text-center text-xl font-semibold">
                            {title}
                        </CredenzaTitle>
                    </CredenzaHeader>
                )}

                <CredenzaBody className={title ? "mt-5" : "mt-0"}>
                    <div className="flex w-full justify-center">
                        {formComponent}
                    </div>
                </CredenzaBody>
            </CredenzaContent>
        </Credenza>
    );
}
